import React, { useState }  from 'react';
import TopbarIconLogo       from "./TopbarIconLogo";

import TopbarItems from "./TopbarItems";


export default function Topbar() {

    return (
        <nav className="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
            <TopbarIconLogo />
            <TopbarItems />
        </nav>
    );
}